"use client";
import React, { useState, useRef, useEffect } from "react";
import { headerLinks } from "./HeaderLinksRenderer";
import { HealthInsuranceDropdown } from "./HealthInsuranceDropdown";
import menuLogo from "../../assets/images/header/png/logo.png";
import ServiceHeader from "./ServiceHeader";
import HeaderMarquee from "./HeaderMarquee";

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(null);
  const menuRefs = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeMenu !== null &&
        !menuRefs.current[activeMenu]?.contains(event.target)
      ) {
        setActiveMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeMenu]);

  const handleMouseEnter = (index) => {
    setActiveMenu(index);
  };

  return (
    <header className="z-10 bg-white">
      <ServiceHeader />
      <div className="bg-white w-full md:px-[120px] flex flex-row items-center justify-between shadow-slate-300 shadow-md">
        <div className="m-3">
          <img src={menuLogo} alt="logo" width={220} height={35} />
        </div>
        <nav className="md:flex hidden flex-row text-black gap-6">
          {/* {headerLinks.map((link, index) => (
                        <div
                            key={index}
                            className='relative'
                            ref={el => menuRefs.current[index] = el}
                            onMouseEnter={() => handleMouseEnter(index)}
                        >
                            <a href={link.link} className="flex gap-1 flex-row py-2 text-sm">
                                {link.name}
                                <p>{link.subItems || link.complexDropdown ? (activeMenu === index ? '-' : '+') : null}</p>
                            </a>
                            {link.subItems && activeMenu === index && (
                                <div className='absolute left-0 mt-2 w-[200px] bg-white border border-gray-200 shadow-lg'>
                                    <ul>
                                        {link.subItems.map((subItem, subIndex) => (
                                            <li key={subIndex} className='px-4 py-2 hover:bg-gray-100'>
                                                <a href={subItem.link}>
                                                    {subItem.name}
                                                    {subItem.isNew && <span className="ml-2 text-xs text-red-500 animate-pulse">NEW</span>}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {link.complexDropdown && activeMenu === index && <HealthInsuranceDropdown />}
                        </div>
                    ))} */}
          {/* <button className='bg-blue-500 text-white px-4 py-2 rounded-md'>Search</button> */}
        </nav>
        {/* <div
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
                >
                    {isMenuOpen ? 'Close' : 'Menu'}
                </div> */}

        {/* {isMenuOpen && (
                    <ul className="flex flex-col absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500 pt-20 px-4">
                        {headerLinks.map((link, index) => (
                            <li
                                key={index}
                                className="px-4 cursor-pointer py-2 text-xl"
                            >
                                <a href={link.link} onClick={() => {
                                    link.complexDropdown || link.subItems ? setAccordionOpen(index) : setIsMenuOpen(false)
                                }}>
                                    {link.name}
                                    {accordionOpen === index ? '-' : '+'}
                                </a>
                                {accordionOpen === index && (
                                    <div className='absolute left-0 mt-2 w-[200px] bg-white border border-gray-200 shadow-lg'>
                                        <ul>
                                            {link.subItems.map((subItem, subIndex) => (
                                                <li key={subIndex} className='px-4 py-2 hover:bg-gray-100'>
                                                    <Link href={subItem.link}>
                                                        {subItem.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </li>

                        ))}
                    </ul>
                )} */}
      </div>
      {/* <HeaderMarquee /> */}
    </header>
  );
};

export default Header;
